// Плашка «Правосвод обновился»: вкладка открыта до выкладки новой версии (lib/version.ts).
import { useStore } from "../lib/reactive";
import { newVersionStore } from "../lib/version";

export function UpdateBanner() {
  const stale = useStore(newVersionStore);
  if (!stale) return null;
  return (
    <div className="update-banner" role="status">
      <span>Правосвод обновился. Обновите страницу, чтобы ответы показывались полностью.</span>
      <button type="button" onClick={() => location.reload()}>Обновить</button>
    </div>
  );
}
